import { render } from "./applySettingsToRoomsModal.vue?vue&type=template&id=440617a5&ts=true"
import script from "./applySettingsToRoomsModal.ts?vue&type=script&lang=ts"
export * from "./applySettingsToRoomsModal.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__